import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f26291e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-bottom__control__inner" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "modal-bottom__title"
}
const _hoisted_4 = { class: "modal-bottom__header d-flex align-start" }
const _hoisted_5 = { class: "modal-bottom__content" }

import { PropType, computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useSwipe } from '@vueuse/core';

import { TFunction } from '@/types/TFunction';

import { useCommonStore } from '@/store/common';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AiBottomModal',
  props: {
  showModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  handleToggle: {
    type: Function as PropType<TFunction>,
    required: true,
  },
  title: {
    type: String as PropType<string>,
    required: false,
  },
  background: {
    type: String as PropType<string>,
    required: false,
  },
  noHeight: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const { isMobile } = storeToRefs(useCommonStore());

const modalActivator = ref<HTMLElement | null>(null);
const modalBody = ref<HTMLElement | null>(null);
const bottom = ref('0');

const containerHeight = computed(() => modalBody.value?.offsetHeight);
const contentClass = computed(() => {
  const classes = ['modal-bottom'];
  if (isMobile.value) {
    classes.push('modal-bottom--mobile');
  }
  return classes.join(' ');
});
const style = computed(() => {
  const result: any = {};
  if (props.background) {
    result.background = `${props.background}`;
  }
  return result;
});

const { lengthY } = useSwipe(modalActivator, {
  onSwipe() {
    bottom.value = lengthY.value < 0 ? `${lengthY.value}px` : '0';
  },
  onSwipeEnd() {
    if (lengthY.value < 0 && containerHeight.value && Math.abs(lengthY.value) / containerHeight.value >= 0.3) {
      bottom.value = '-100%';
      // infoShow.value = false;
      props.handleToggle(props.showModal);
    } else {
      bottom.value = '0';
    }
  },
});

watch(
  () => props.showModal,
  () => {
    bottom.value = '0';
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": props.showModal,
    "onUpdate:modelValue": props.handleToggle,
    "content-class": contentClass.value,
    style: _normalizeStyle(style.value),
    attach: ".app-template",
    scrim: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "modal-bottom__background",
        onKeydown: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (__props.handleToggle && __props.handleToggle(...args)), ["esc"])),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.handleToggle && __props.handleToggle(...args)))
      }, null, 32),
      _createElementVNode("div", {
        class: _normalizeClass(["modal-bottom__body", { 'modal-bottom__body--no-height': props.noHeight }]),
        style: _normalizeStyle({ bottom: bottom.value }),
        ref_key: "modalBody",
        ref: modalBody
      }, [
        (_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-bottom__control",
              ref_key: "modalActivator",
              ref: modalActivator
            }, _hoisted_2, 512))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-bottom__header d-flex align-start", { 'modal-bottom__header--no-subtitle': _ctx.$slots.subtitle }])
        }, [
          (props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.title), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_v_spacer),
          _createVNode(AiClearButton, {
            onClick: __props.handleToggle,
            class: "modal-bottom__close"
          }, {
            default: _withCtx(() => [
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(_component_inline_svg, {
                    key: 0,
                    src: require('@/assets/icons/IconCloseMobile.svg')
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(_component_inline_svg, {
                    key: 1,
                    src: require('@/assets/icons/IconClose.svg')
                  }, null, 8, ["src"]))
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "subtitle")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 6)
    ]),
    _: 3
  }, 8, ["model-value", "onUpdate:modelValue", "content-class", "style"]))
}
}

})